import { PdfViewer } from '@/components/pdfViewer';
import { SelectedInvoice } from '@/components/RelationActionMenu/Invoice/type';
import { useGetMfFileAndObjectURL } from '@service/mf_file/MfFile.service';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './Preview.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  invoice: SelectedInvoice;
};

export const SelectedInvoicePreview: FC<Props> = memo(({ invoice }) => {
  const { url } = useGetMfFileAndObjectURL(invoice.mfFileId);

  return (
    <div className={cx(styles['preview-container'])}>
      <PdfViewer src={url} />
    </div>
  );
});
SelectedInvoicePreview.displayName = 'SelectedInvoicePreview';
